export const formatErrorMessage = (
  error: any,
  fallbackMessage = "An error occurred"
) => {
  error = error?.data || error;
  if (error?.errorFields) {
    return error?.errorFields
      ?.map((e: any) => e?.errors?.join(", "))
      ?.join(", ");
  }
  if (error?.networkError?.result?.errors?.length) {
    return error?.networkError?.result?.errors?.reduce(
      (errorMessage: string, e: any) => `${errorMessage}, ${e?.message}`,
      fallbackMessage
    );
  }
  return (
    (error?.response &&
      error?.response?.data &&
      error?.response?.data?.message) ||
    error?.error?.message ||
    error?.message ||
    (typeof error === "string" && error) ||
    fallbackMessage
  );
};
